import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { InputText } from 'primeng/inputtext';

/**
 * Text input for an icon css class (Font Awesome, e.g. `fa-solid fa-ship`) with a live preview of the icon in
 * front of it. On blur the value is trimmed and inner blanks are collapsed; an empty value is stored as null.
 */
@Component({
  selector: 'app-formly-icon-css-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormlyModule, InputText],
  template: `
    <div class="flex items-center gap-2">
      <span
        class="inline-flex items-center justify-center w-9 h-9 shrink-0 text-lg border rounded-md border-surface-200 dark:border-surface-700"
        aria-hidden="true"
        [attr.data-testid]="dataTestId + '-preview'"
      >
        @if (formControl.value) {
          <i [class]="formControl.value"></i>
        }
      </span>
      <input
        pInputText
        type="text"
        class="w-full min-w-0"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [placeholder]="props.placeholder ?? ''"
        [readonly]="props.readonly"
        [attr.data-testid]="dataTestId"
        (blur)="normalize()"
      />
    </div>
    @if (props.hint) {
      <small class="block mt-1 text-xs text-muted-color">{{ props.hint }}</small>
    }
  `,
})
export class FormlyIconCssInputComponent extends FieldType<FieldTypeConfig> {

  get dataTestId(): string {
    return this.props.attributes?.['data-testid'] as string ?? 'formly-icon-css';
  }

  normalize(): void {
    const value = this.formControl.value;
    if (typeof value !== 'string') {
      return;
    }
    const cleaned = value.trim().replace(/\s+/g, ' ') || null;
    if (cleaned !== value) {
      this.formControl.setValue(cleaned);
      this.formControl.markAsDirty();
    }
  }
}
